export default __webpack_public_path__ + "static/media/down.c6fbe28e.png";